export default __webpack_public_path__ + "static/media/pic1.5ab1cb33.jfif";